
















































import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'
import { ApplicationState } from './store'
import PageError from '@/containers/Pages/Error.vue'
import ToolTestingBg from '@/containers/Tools/TestingBg.vue'
import ModalNewVersion from '@/containers/Modals/NewVersion.vue'

@Component({
	components: {
		PageError,
		ModalNewVersion,
		ToolTestingBg,
	},
})
export default class App extends Vue {
	@State((state: ApplicationState) => {
		// console.log(state)

		return state.Base.error
	})
	errorStatus!: ApplicationState['Base']['error']

	get textDirection() {
		return this.$store.state.i18n.locale === 'he' ? 'rtl' : ''
	}

	created() {
		/**
		 * If query has `lang` param - set
		 * this language and remove it from route
		 */
		if (this.$route.query.lang) {
			const locale = (this.$route.query.lang as string).toLowerCase()
			window.localStorage.setItem('defaultLanguage', locale as string)
			this.$i18n.set(locale)
		}
	}
}
